import { eq } from "drizzle-orm";
import { attachment, type PowerSyncDrizzleDB } from "@folio/powersync";
import { nowISO } from "../utils/date-helpers";
import { generateId } from "@fleet/utils";

export async function addPageAttachmentMutation({
  db,
  pageId,
  userId,
  filename,
  url,
  contentType,
  size,
}: {
  db: PowerSyncDrizzleDB;
  pageId: string;
  userId: string;
  filename: string;
  url: string;
  contentType: string;
  size: number;
}) {
  const id = generateId();
  const now = nowISO();
  await db.insert(attachment).values({
    id,
    page_id: pageId,
    user_id: userId,
    filename,
    url,
    content_type: contentType,
    size,
    created_at: now,
    updated_at: now,
  });
  return id;
}

export async function deleteAttachmentMutation(db: PowerSyncDrizzleDB, id: string) {
  await db.delete(attachment).where(eq(attachment.id, id));
}
